import WizardAssistantAPI from 'dashboard/api/wizard/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'WizardAssistant',
  API: WizardAssistantAPI,
});
